(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('MoveSoopController', MoveSoopController);

    MoveSoopController.$inject = ['SoopService', '$rootScope', '$controller', '$sce', '$uibModalInstance', 'entity', 'AlertService', 'parameters', 'SoopkitchenUtils'];

    function MoveSoopController(SoopService, $rootScope, $controller, $sce, $uibModalInstance, entity, AlertService, parameters, SoopkitchenUtils) {

        var vm = this;

        vm.planLabel = parameters.planLabel;
        vm.soopInstanceId = parameters.soopInstanceId;
        vm.encodedSoopType = parameters.encodedSoopType;
        vm.soopType = parameters.soopType;
        vm.anchorTime = parameters.anchorDate;
        vm.planType = parameters.planType;
        vm.cut = parameters.cut;
        
        var titlePrefix = "Copy and paste";
        if (vm.cut) titlePrefix = "Cut and paste";

        var title = titlePrefix + ' SOOP ' + vm.soopType + ': <span class="label label-info">' + vm.encodedSoopType + '_' + vm.soopInstanceId + '</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance: $uibModalInstance}));

        //Overriding Properties from SoopkitchenDialogController:
        vm.saveDisabled = false;
        vm.saveText = "Apply";

        /**** Methods ****/
        vm.isValidDate = isValidDate;

        //Override Methods from SoopkitchenDialogController
        vm.save = moveSoop;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValidDate(date) {
            if (date == null || date === '') {
                vm.saveDisabled = true;
                return false;
            }
            vm.saveDisabled = false === SoopkitchenUtils.isValidDate(date);
            return SoopkitchenUtils.isValidDate(date);
        }

        function successCallback(response) {
            return function() {
                vm.waiting = false;
                SoopkitchenUtils.updatePlanFromDialog(response.data);
                $uibModalInstance.dismiss('cancel');
            }
        }

        function extraErrorCallback() {
            vm.waiting = false;
        }

        function moveSoop() {
            vm.waiting = true;
            SoopService.moveSoop(vm.planType, vm.planLabel, vm.soopInstanceId, vm.encodedSoopType, vm.soopType, vm.anchorTime, vm.cut, successCallback, extraErrorCallback);
        }

    }
})();
